enum PaymentRemittancesActionType {
  ADD_COMMENT = 'add-comment',
  APPROVE = 'approve',
  CHANGE_METHOD = 'change-method',
  DISAPPROVE = 'disapprove',
  EDIT = 'edit',
  GENERATE_INVOICE = 'generate-invoice',
  GENERATE_REMITTANCE = 'generate-remittance',
  GENERATE_REPORT = 'generate-report',
  DOWNLOAD_RECEIPT = 'download-receipt',
  REMOVE = 'remove',
  REMOVE_INVOICE = 'remove-invoice',
  VIEW_DETAILS = 'view-details',
  VIEW_INVOICE = 'view-invoice',
  ADD_INCREASE_OR_DECREASE = 'add-increase-or-decrease',
  CHANGE_VALUE = 'change-value',
  CHANGE_DATE = 'change-date'
}

export default PaymentRemittancesActionType;
